import React, {FC, useState, useEffect} from 'react'
import {UseFormRegister, FieldErrors, useFormContext, Controller} from 'react-hook-form'
import {useCentral} from '../../../hooks/useCentral'
import {TabCentralModel} from '../../../models'
type InputProps = {
  name: string
  textPlaceholder?: string
  register: UseFormRegister<any>
  errors: FieldErrors
  disabled?: boolean
  Uppercase?: boolean
  type?: string
  maxLength?: number
}

const InputText: FC<InputProps> = ({
  name,
  textPlaceholder,
  maxLength = 1000,
  disabled = false,
  register,
  Uppercase = false,
  errors,
  type = 'text',
  ...props
}) => {
  const {currentTabItem, changeCurrentTabItem} = useCentral()

  const {getValues, setError, control} = useFormContext()
  const [inputValue, setInputValue] = useState(getValues(name))

  // Manejar cambios en el valor del campo y convertir a mayúsculas
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = Uppercase ? e.target.value.toUpperCase() : e.target.value
    setError(name, {})
    setInputValue(value)
  }

  useEffect(() => {
    if (currentTabItem.reset) {
      setInputValue('')
      const obj: TabCentralModel = {
        ...currentTabItem,
        reset: false,
      }
      changeCurrentTabItem(obj)
    }
  }, [currentTabItem.reset])

  return (
    <div className='sdx_form_input'>
      <Controller
        name={name}
        control={control}
        render={({field}) => (
          <input
            type={type}
            className='form-control sdx-centra-input-form'
            {...field}
            // pattern="[A-Z]*" // Patrón para permitir solo letras mayúsculas
            placeholder={textPlaceholder}
            maxLength={maxLength}
            disabled={disabled}
            onChange={(e) => {
              const upperCaseValue = e.target.value.toUpperCase()
              field.onChange(upperCaseValue)
            }}
          />
        )}
      />
      {/* <input
        type={type}
        className='form-control sdx-centra-input-form'
        {...register(name)}
        placeholder={textPlaceholder}
        disabled={disabled}
        value={inputValue}
        onChange={handleInputChange}
        {...props}
      /> */}
      {errors[name] && <p>{errors[name]?.message?.toString()}</p>}
    </div>
  )
}

export default InputText
